class FetchDocumentTemplateVersions {
	constructor(public readonly organizationId: number) {
		Object.freeze(this);
	}
}

export default FetchDocumentTemplateVersions;
